import { computed, Directive, inject, input, Signal } from '@angular/core';
import { PaginationStore } from '../services/stores/pagination.store';
import { SelectionStore } from '../services/stores/selection.store';
import { buildConf, mapRows } from '../shared/table-config';
import { BaseColumn } from './dsy-table.model';

@Directive()
export abstract class BaseTableComponent<Log extends Object, ColumnKey extends string> {
  readonly rowsSignal = input.required<readonly Log[]>({ alias: 'rows' });

  readonly selectionStore = inject(SelectionStore);
  readonly paginationStore = inject(PaginationStore);
  readonly columnsSignal: Signal<readonly BaseColumn<Log, ColumnKey>[]>;

  constructor(columnsSignal: Signal<readonly BaseColumn<Log, ColumnKey>[]>) {
    this.columnsSignal = columnsSignal;
  }

  readonly isSelected = (id: string) => this.selectionStore.isSelected(id);
  readonly handleToggleAll = () => this.selectionStore.toggleAll();
  readonly handleToggleRow = (id: string) => () => this.selectionStore.toggleRow(id);

  readonly tableDataSignal = computed(() => mapRows<Log, ColumnKey>(this.rowsSignal(), this.columnsSignal()));
  readonly tableConfSignal = computed(() =>
    buildConf<Log, ColumnKey>(
      this.columnsSignal(),
      this.tableDataSignal().map((r) => r.id)
    )
  );
}
